// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VendorModal_authCommonSection__rhRHc {
  width: 100%;
  min-height: calc(100dvh - 0px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
}
.VendorModal_authCommonSection__rhRHc .VendorModal_inner__C-KBm {
  max-width: 960px;
  width: 100%;
  margin: 0 auto;
  box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.1607843137);
  border-radius: var(--border-radius-large);
  overflow: hidden;
  position: relative;
  z-index: 1;
  max-height: 100dvh;
  min-height: 600px;
}
.VendorModal_authCommonSection__rhRHc .VendorModal_inner__C-KBm .VendorModal_bgImg__fwplc {
  position: absolute;
  bottom: -90px;
  right: -70px;
  width: 310px;
  height: 307px;
  z-index: 1;
  opacity: 0.5;
}
.VendorModal_authCommonSection__rhRHc .VendorModal_inner__C-KBm .VendorModal_bgImg__fwplc img {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
}
.VendorModal_authCommonSection__rhRHc .VendorModal_imageContainer__J56Ae {
  padding: 30px 45px;
  background-color: rgba(255, 255, 255, 0.3019607843);
  height: 100%;
}
.VendorModal_authCommonSection__rhRHc .VendorModal_imageContainer__J56Ae img {
  width: 100%;
  border-radius: 8px;
  object-fit: cover;
  object-position: top;
  height: 100%;
  min-height: 540px;
}
.VendorModal_authCommonSection__rhRHc .VendorModal_formContainer__TCt8T {
  padding: 48px 52px;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #faf4f2;
  justify-content: space-between;
  height: 100%;
}
.VendorModal_authCommonSection__rhRHc .VendorModal_formContainer__TCt8T > div {
  position: relative;
  z-index: 2;
}
.VendorModal_authCommonSection__rhRHc .VendorModal_formContainer__TCt8T .VendorModal_titleContainer__hCCVR {
  text-align: center;
  margin: 0;
}
.VendorModal_authCommonSection__rhRHc .VendorModal_formContainer__TCt8T .VendorModal_titleContainer__hCCVR h4 {
  font: var(--h3);
  font-family: var(--font-bodoni);
  color: var(--primary-Text);
  margin-bottom: 8px;
  text-transform: capitalize;
}
.VendorModal_authCommonSection__rhRHc .VendorModal_formContainer__TCt8T .VendorModal_titleContainer__hCCVR p {
  font: var(--h1);
  font-size: 48px;
  color: var(--primary-Text);
  font-family: var(--font-alex);
}
.VendorModal_authCommonSection__rhRHc .VendorModal_formContainer__TCt8T .VendorModal_titleContainer__hCCVR p a {
  color: var(--primary-color);
  margin-left: 2px;
}
.VendorModal_authCommonSection__rhRHc .VendorModal_formContainer__TCt8T .VendorModal_titleContainer__hCCVR p a:hover {
  text-decoration: underline;
}

.VendorModal_titleContainer__hCCVR {
  margin-bottom: 30px;
}
.VendorModal_titleContainer__hCCVR .VendorModal_title__syGWb {
  font: var(--h3);
  font-family: var(--font-bodoni);
  color: #313131;
  margin-bottom: 12px;
}
.VendorModal_titleContainer__hCCVR .VendorModal_subTitle__Y1akX {
  font: var(--body-font-three);
  color: #7ca6bd;
}
.VendorModal_titleContainer__hCCVR .VendorModal_modalSemiTitle__yT3eG {
  font: var(--body-font-three);
  color: var(--secondary-Text);
}

.VendorModal_priceRange__e\\+4vs {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid var(--border);
  padding: 11px 12px;
  border-radius: 8px;
  background: var(--white);
  width: fit-content;
  margin: 0 auto;
  margin-bottom: 22px;
}
.VendorModal_priceRange__e\\+4vs input {
  max-width: max-content;
  width: fit-content;
  background: none;
  border: none;
  outline: none;
  text-align: center;
  padding: 0;
  margin: 0;
  text-align: center;
}

.VendorModal_buttonContainer__\\+n5Pz {
  width: 100%;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

@media (max-width: 1170px) {
  .VendorModal_authCommonSection__rhRHc {
    min-height: calc(100dvh - 69px);
  }
  .VendorModal_authCommonSection__rhRHc .VendorModal_inner__C-KBm .VendorModal_bgImg__fwplc {
    bottom: -100px;
    width: 270px;
  }
}
@media (max-width: 991px) {
  .VendorModal_authCommonSection__rhRHc {
    min-height: calc(100dvh - 72px);
  }
  .VendorModal_authCommonSection__rhRHc .VendorModal_imageContainer__J56Ae {
    padding: 20px 30px;
  }
  .VendorModal_authCommonSection__rhRHc .VendorModal_formContainer__TCt8T {
    padding: 20px 30px;
  }
  .VendorModal_authCommonSection__rhRHc .VendorModal_formContainer__TCt8T .VendorModal_titleContainer__hCCVR h4 {
    font-size: 26px;
  }
}
@media (max-width: 767px) {
  .VendorModal_authCommonSection__rhRHc .VendorModal_imageContainer__J56Ae {
    padding: 20px 15px;
  }
  .VendorModal_authCommonSection__rhRHc .VendorModal_formContainer__TCt8T {
    padding: 20px 15px;
  }
  .VendorModal_authCommonSection__rhRHc .VendorModal_formContainer__TCt8T .VendorModal_titleContainer__hCCVR h4 {
    font-size: 22px;
    margin-bottom: 5px;
  }
}
@media (max-width: 599px) {
  .VendorModal_authCommonSection__rhRHc {
    min-height: calc(100dvh - 66px);
  }
  .VendorModal_authCommonSection__rhRHc .VendorModal_inner__C-KBm .VendorModal_bgImg__fwplc {
    display: none;
  }
  .VendorModal_authCommonSection__rhRHc .VendorModal_imageContainer__J56Ae {
    display: none;
  }
  .VendorModal_CommonSectionModals__FJX\\+K .VendorModal_inner__C-KBm {
    overflow-y: auto;
    min-height: 100%;
    max-height: 80dvh;
    justify-content: center;
  }
  .VendorModal_CommonSectionModals__FJX\\+K .VendorModal_formContainer__TCt8T {
    height: auto;
    min-height: 100%;
    max-height: max-content;
  }
  .VendorModal_CommonSectionModals__FJX\\+K .VendorModal_formContainer__TCt8T .VendorModal_gridBox__5PNYs {
    height: auto;
    min-height: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/VenderModal/VendorModal.module.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACD;AACC;EACC,gBAAA;EACA,WAAA;EACA,cAAA;EACA,wDAAA;EACA,yCAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EAEA,kBAAA;EACA,iBAAA;AAAF;AAEE;EACC,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;AAAH;AAEG;EACC,WAAA;EACA,YAAA;EACA,sBAAA;AAAJ;AAKC;EACC,kBAAA;EACA,mDAAA;EACA,YAAA;AAHF;AAKE;EACC,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,iBAAA;AAHH;AAQC;EACC,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,8BAAA;EACA,YAAA;AANF;AAQE;EACC,kBAAA;EACA,UAAA;AANH;AASE;EACC,kBAAA;EACA,SAAA;AAPH;AASG;EACC,eAAA;EACA,+BAAA;EACA,0BAAA;EACA,kBAAA;EACA,0BAAA;AAPJ;AAUG;EACC,eAAA;EACA,eAAA;EACA,0BAAA;EACA,6BAAA;AARJ;AAUI;EACC,2BAAA;EACA,gBAAA;AARL;AAUK;EACC,0BAAA;AARN;;AAgBA;EACC,mBAAA;AAbD;AAeC;EACC,eAAA;EACA,+BAAA;EACA,cAAA;EACA,mBAAA;AAbF;AAgBC;EACC,4BAAA;EACA,cAAA;AAdF;AAiBC;EACC,4BAAA;EACA,4BAAA;AAfF;;AAmBA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAhBD;AAkBC;EACC,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AAhBF;;AAoBA;EACC,WAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;AAjBD;;AAoBA;EACC;IACC,+BAAA;EAjBA;EAoBC;IACC,cAAA;IACA,YAAA;EAlBF;AACF;AAyBA;EACC;IACC,+BAAA;EAvBA;EAyBA;IACC,kBAAA;EAvBD;EA0BA;IACC,kBAAA;EAxBD;EA2BE;IACC,eAAA;EAzBH;AACF;AA+BA;EAEE;IACC,kBAAA;EA9BD;EAiCA;IACC,kBAAA;EA/BD;EAkCE;IACC,eAAA;IACA,kBAAA;EAhCH;AACF;AAsCA;EACC;IACC,+BAAA;EApCA;EAuCC;IACC,aAAA;EArCF;EAyCA;IACC,aAAA;EAvCD;EA4CA;IACC,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,uBAAA;EA1CD;EA6CA;IACC,YAAA;IACA,gBAAA;IACA,uBAAA;EA3CD;EA6CC;IACC,YAAA;IACA,gBAAA;EA3CF;AACF","sourcesContent":[".authCommonSection {\r\n\twidth: 100%;\r\n\tmin-height: calc(100dvh - 0px);\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tpadding: 20px 0;\r\n\r\n\t.inner {\r\n\t\tmax-width: 960px;\r\n\t\twidth: 100%;\r\n\t\tmargin: 0 auto;\r\n\t\tbox-shadow: 0px 0px 32px 0px #00000029;\r\n\t\tborder-radius: var(--border-radius-large);\r\n\t\toverflow: hidden;\r\n\t\tposition: relative;\r\n\t\tz-index: 1;\r\n\r\n\t\tmax-height: 100dvh;\r\n\t\tmin-height: 600px;\r\n\r\n\t\t.bgImg {\r\n\t\t\tposition: absolute;\r\n\t\t\tbottom: -90px;\r\n\t\t\tright: -70px;\r\n\t\t\twidth: 310px;\r\n\t\t\theight: 307px;\r\n\t\t\tz-index: 1;\r\n\t\t\topacity: 0.5;\r\n\r\n\t\t\timg {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.imageContainer {\r\n\t\tpadding: 30px 45px;\r\n\t\tbackground-color: #ffffff4d;\r\n\t\theight: 100%;\r\n\r\n\t\timg {\r\n\t\t\twidth: 100%;\r\n\t\t\tborder-radius: 8px;\r\n\t\t\tobject-fit: cover;\r\n\t\t\tobject-position: top;\r\n\t\t\theight: 100%;\r\n\t\t\tmin-height: 540px;\r\n\t\t\t// max-height: 540px;\r\n\t\t}\r\n\t}\r\n\r\n\t.formContainer {\r\n\t\tpadding: 48px 52px;\r\n\t\tmax-height: 100%;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tbackground-color: #faf4f2;\r\n\t\tjustify-content: space-between;\r\n\t\theight: 100%;\r\n\r\n\t\t& > div {\r\n\t\t\tposition: relative;\r\n\t\t\tz-index: 2;\r\n\t\t}\r\n\r\n\t\t.titleContainer {\r\n\t\t\ttext-align: center;\r\n\t\t\tmargin: 0;\r\n\r\n\t\t\th4 {\r\n\t\t\t\tfont: var(--h3);\r\n\t\t\t\tfont-family: var(--font-bodoni);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tmargin-bottom: 8px;\r\n\t\t\t\ttext-transform: capitalize;\r\n\t\t\t}\r\n\r\n\t\t\tp {\r\n\t\t\t\tfont: var(--h1);\r\n\t\t\t\tfont-size: 48px;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tfont-family: var(--font-alex);\r\n\r\n\t\t\t\ta {\r\n\t\t\t\t\tcolor: var(--primary-color);\r\n\t\t\t\t\tmargin-left: 2px;\r\n\r\n\t\t\t\t\t&:hover {\r\n\t\t\t\t\t\ttext-decoration: underline;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.titleContainer {\r\n\tmargin-bottom: 30px;\r\n\r\n\t.title {\r\n\t\tfont: var(--h3);\r\n\t\tfont-family: var(--font-bodoni);\r\n\t\tcolor: #313131;\r\n\t\tmargin-bottom: 12px;\r\n\t}\r\n\r\n\t.subTitle {\r\n\t\tfont: var(--body-font-three);\r\n\t\tcolor: #7ca6bd;\r\n\t}\r\n\r\n\t.modalSemiTitle {\r\n\t\tfont: var(--body-font-three);\r\n\t\tcolor: var(--secondary-Text);\r\n\t}\r\n}\r\n\r\n.priceRange {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tgap: 8px;\r\n\tborder: 1px solid var(--border);\r\n\tpadding: 11px 12px;\r\n\tborder-radius: 8px;\r\n\tbackground: var(--white);\r\n\twidth: fit-content;\r\n\tmargin: 0 auto;\r\n\tmargin-bottom: 22px;\r\n\r\n\tinput {\r\n\t\tmax-width: max-content;\r\n\t\twidth: fit-content;\r\n\t\tbackground: none;\r\n\t\tborder: none;\r\n\t\toutline: none;\r\n\t\ttext-align: center;\r\n\t\tpadding: 0;\r\n\t\tmargin: 0;\r\n\t\ttext-align: center;\r\n\t}\r\n}\r\n\r\n.buttonContainer {\r\n\twidth: 100%;\r\n\ttext-align: right;\r\n\tdisplay: flex;\r\n\tjustify-content: flex-end;\r\n\tmargin-top: 20px;\r\n}\r\n\r\n@media (max-width: 1170px) {\r\n\t.authCommonSection {\r\n\t\tmin-height: calc(100dvh - 69px);\r\n\r\n\t\t.inner {\r\n\t\t\t.bgImg {\r\n\t\t\t\tbottom: -100px;\r\n\t\t\t\twidth: 270px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\r\n\t}\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\t.authCommonSection {\r\n\t\tmin-height: calc(100dvh - 72px);\r\n\r\n\t\t.imageContainer {\r\n\t\t\tpadding: 20px 30px;\r\n\t\t}\r\n\r\n\t\t.formContainer {\r\n\t\t\tpadding: 20px 30px;\r\n\r\n\t\t\t.titleContainer {\r\n\t\t\t\th4 {\r\n\t\t\t\t\tfont-size:26px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.authCommonSection {\r\n\t\t.imageContainer {\r\n\t\t\tpadding: 20px 15px;\r\n\t\t}\r\n\r\n\t\t.formContainer {\r\n\t\t\tpadding: 20px 15px;\r\n\r\n\t\t\t.titleContainer {\r\n\t\t\t\th4 {\r\n\t\t\t\t\tfont-size: 22px;\r\n\t\t\t\t\tmargin-bottom: 5px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 599px) {\r\n\t.authCommonSection {\r\n\t\tmin-height: calc(100dvh - 66px);\r\n\r\n\t\t.inner {\r\n\t\t\t.bgImg {\r\n\t\t\t\tdisplay: none;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.imageContainer {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\t}\r\n\r\n\t.CommonSectionModals {\r\n\t\t.inner {\r\n\t\t\toverflow-y: auto;\r\n\t\t\tmin-height: 100%;\r\n\t\t\tmax-height: 80dvh;\r\n\t\t\tjustify-content: center;\r\n\t\t}\r\n\r\n\t\t.formContainer {\r\n\t\t\theight: auto;\r\n\t\t\tmin-height: 100%;\r\n\t\t\tmax-height: max-content;\r\n\r\n\t\t\t.gridBox {\r\n\t\t\t\theight: auto;\r\n\t\t\t\tmin-height: 100%;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"authCommonSection": `VendorModal_authCommonSection__rhRHc`,
	"inner": `VendorModal_inner__C-KBm`,
	"bgImg": `VendorModal_bgImg__fwplc`,
	"imageContainer": `VendorModal_imageContainer__J56Ae`,
	"formContainer": `VendorModal_formContainer__TCt8T`,
	"titleContainer": `VendorModal_titleContainer__hCCVR`,
	"title": `VendorModal_title__syGWb`,
	"subTitle": `VendorModal_subTitle__Y1akX`,
	"modalSemiTitle": `VendorModal_modalSemiTitle__yT3eG`,
	"priceRange": `VendorModal_priceRange__e+4vs`,
	"buttonContainer": `VendorModal_buttonContainer__+n5Pz`,
	"CommonSectionModals": `VendorModal_CommonSectionModals__FJX+K`,
	"gridBox": `VendorModal_gridBox__5PNYs`
};
export default ___CSS_LOADER_EXPORT___;
